import { createSelector } from 'reselect';

export default createSelector(
    (state) => state.CommonPrefixes,
    (state) => state.Contents,
    (state) => state.selection,
    (CommonPrefixes, Contents, selection) => {
        const prefixes = [];
        const contents = [];
        const hash = {};

        for (const { Prefix } of CommonPrefixes) {
            if (selection[Prefix]) {
                prefixes.push(Prefix);
                hash[Prefix] = true;
            }
        }

        for (const { Key } of Contents) {
            if (selection[Key]) {
                contents.push(Key);
                hash[Key] = true;
            }
        }

        return {
            prefixes,
            contents,
            hash,
        };
    },
);
